import { useEffect } from 'react'
import { findDOMNode } from 'react-dom'

/*
  This hook is used to disable text selection on a div element
*/
export const nonSelectableElementHook = (ref: React.RefObject<HTMLDivElement>) => {
  useEffect(() => {
    if (ref.current) {
      // add style to iframe wrapper
      const divWrapper = findDOMNode(ref.current) as HTMLDivElement
      divWrapper.style.userSelect = 'none'
      divWrapper.style.webkitUserSelect = 'none'
    }
  }, [])
}
